/*
 * 1DS JSLL SKU, 3.2.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
import { notImplementedWarn } from "./Utils";
var TimespanHandler = /** @class */ (function () {
    function TimespanHandler() {
    }
    TimespanHandler.prototype.recordTimeSpan = function (counterName, isComplete) {
        // JSLL use this to calculate time in Qos requests.
        // NO OP
        notImplementedWarn("recordTimeSpan");
        return -1;
    };
    return TimespanHandler;
}());
export { TimespanHandler };
//# sourceMappingURL=TimespanHandler.js.map